import { render } from "./UIModal.vue?vue&type=template&id=f89aa390&scoped=true&ts=true"
import script from "./UIModal.vue?vue&type=script&lang=ts"
export * from "./UIModal.vue?vue&type=script&lang=ts"

import "./UIModal.vue?vue&type=style&index=0&id=f89aa390&scoped=true&lang=css"

import exportComponent from "/root/app/github/pehuen-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f89aa390"]])

export default __exports__